import React, { useState, useEffect } from 'react';
import { BsCircleFill } from 'react-icons/bs';
import { FaEye } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { Card, Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { commafy, uiLabel } from 'Utils';
import PerfectScrollbar from 'react-perfect-scrollbar';


const healthcareDbIdentifiers = ["DRUG", "DIAGNOSIS", "INSURANCE", "IMMUNIZATION"];


const OverviewTable = (props) => {
  const [sortable, setSortable] = useState([]);
  const [sortedBy, setSortedBy] = useState('');
  const [sortAsc, setSortAsc] = useState(false);
  const [more, setMore] = useState(null);
  const donutLevel = props.donutLevel;
  const dataLabel = props.dataLabel || 'tables';

  useEffect(() => {
    const sortableArr = [];
    let moreData;

    for (let i = 0; i < props.data.length; i++) {
      if (props.data[i].type !== 'Low Incidence Findings') {
        sortableArr.push([props.data[i].type, props.data[i].theta, props.data[i].color]);
      } else {
        moreData = props.data[i];
      }
    }

    sortableArr.sort(function(a, b) {
      return b[1] - a[1];
    });
    
    if (moreData) {
      setMore([moreData.type, moreData.theta, moreData.color]);
    } else {
      setMore(null);
    }

    setSortable(sortableArr);
  }, [props.data])

  function handleSortAlpha(arr) {
    let sortableArr = [...arr];

    if (sortAsc) {
      sortableArr.sort((a, b) => (a[0] < b[0] ? -1 : 1));
    } else {
      sortableArr.sort((a, b) => (a[0] < b[0] ? 1 : -1));
    }

    setSortAsc(!sortAsc);
    setSortable(sortableArr);
    setSortedBy("found");
  }

  function handleSortNum(arr) {
    let sortableArr = [...arr];

    if (sortAsc) {
      sortableArr.sort((a, b) => b[1] - a[1]);
    } else {
      sortableArr.sort((a, b) => a[1] - b[1]);
    }

    setSortAsc(!sortAsc);
    setSortable(sortableArr);
    setSortedBy("count");
  }

  return (
    <Card 
      className="shadow-sm widget-card text-left h-100"
      style={{ maxHeight: '100%' }}
    >
          <div className='d-flex flex-column h-100'>
            <Table className='mh-100 d-flex flex-column overview-table h-100'>
              <thead className="widget-table-thead text-left">
                <tr className='d-flex'>
                  <th className='overview-tbl-col1'>
                    <BsCircleFill color='rgba(255,255,255,0)' />
                  </th>
                  <th 
                    className="pointer overview-tbl-col2"
                    onClick={() => handleSortAlpha(sortable)}
                  >
                      Entities
                      {sortedBy === "found" &&
                        (sortAsc ? ' \u25be' : ' \u25b4')
                      }
                  </th>
                  <th
                    className="pointer overview-tbl-col3" 
                    onClick={() => handleSortNum(sortable)}
                  >
                    Count
                    {sortedBy === "count" &&
                      (sortAsc ? ' \u25b4' : ' \u25be')
                    }
                  </th>
                </tr>
              </thead>
                <tbody className='overflow-hidden flex-grow-1'>
                  <PerfectScrollbar>
                    { sortable.map(
                      (pair, index) => (
                        <OverlayTrigger
                          key={index}
                          placement="left"
                          overlay={
                            <Tooltip className="discovery-tooltip">
                              <div className="p-2" >
                                { pair[0] !== "Low Incidence Findings" ?
                                `See ${dataLabel} with ${uiLabel(pair[0])} data` :
                                `Click to see other data found`
                                }
                              </div>
                            </Tooltip>
                          }
                        >
                          <tr className='d-flex overview-tbl-row'>
                            <td className="text-center pointer overview-tbl-col1">
                              <BsCircleFill className="mr-2 mb-1" color={pair[2]} />
                            </td>
                            <td className='overview-tbl-col2'>
                              { pair[0] !== "Low Incidence Findings" ? (
                              <Link
                                // to={`/results/${props.searchid}/${pair[0]}`}
                                to={{
                                  pathname: `/results/${props.searchid}/${pair[0]}`,
                                  state: { lowConfidence: donutLevel === 1 }
                                }}
                              >
                                { uiLabel(pair[0]) }
                                {healthcareDbIdentifiers.includes(pair[0]) && (
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip className="discovery-tooltip">
                                        <div className="p-2">Indicator of Healthcare Database with PHI risk</div>
                                      </Tooltip>
                                    }
                                  >
                                    <FaEye className="ml-2" style={{ fontSize: '12px', color: '#315DFF' }} />
                                  </OverlayTrigger>
                                )}
                              </Link>
                              ) : (
                                <a
                
                                  onClick={() => props.handleSetDonutLevel(1)}
                                  href="javascript:;"
                                >
                                  { uiLabel(pair[0]) }
                                </a>
                              )}
                            </td>
                            <td className='overview-tbl-col3'>
                              { commafy(pair[1]) }
                            </td>
                          </tr>
                        </OverlayTrigger>
                      )
                    )}
                    { more &&
                      <OverlayTrigger
                        placement="left"
                        overlay={
                          <Tooltip className="discovery-tooltip">
                            <div className="p-2">
                              Low Incidence Findings are sensitive entities that were discovered that make up less than 2% of the sampled rows in a given source
                            </div>
                          </Tooltip>
                        }
                      >
                        <tr className='overview-table-divider d-flex'>
                          <td className="text-center pointer overview-tbl-col1">
                            <BsCircleFill className="mr-2 mb-1" color={more[2]} />
                          </td>
                          <td className='overview-tbl-col2'>
                            <a
                              className='low-confidence-findings'
                              onClick={() => props.handleSetDonutLevel(1)}
                            >
                              { more[0] }
                            </a>
                          </td>
                          <td className='overview-tbl-col3'>{ commafy(more[1]) }</td>
                        </tr>
                      </OverlayTrigger>
                    }
                  </PerfectScrollbar>
                </tbody>
                <tfooter style={{ borderTop: '2px solid #D9DDE3' }}>
                  <OverlayTrigger
                    placement="left"
                    overlay={<Tooltip className="discovery-tooltip"><div className="p-2">See all {dataLabel} with sensitive data</div></Tooltip>}
                  >
                    <tr className='d-flex overview-tbl-row'>
                      <td
                        className="text-center pointer overview-tbl-col1"
                      >
                      </td>
                      <td className='overview-tbl-col2'>
                        <b>{donutLevel === 1 ? 'Low Incidence Findings' : 'Total Sensitive Elements Found'}</b>
                      </td>
                      <td className='overview-tbl-col3'>
                        { commafy(donutLevel === 1 ?
                            sortable.map(arr => arr[1]).reduce((a, c) =>  a + c, 0) 
                          : 
                            props.total
                          )
                        }
                      </td>
                    </tr>
                  </OverlayTrigger>
                </tfooter>
            </Table>
          </div>
    </Card>
  );
}

export default OverviewTable;